<template>
  <b-modal
    hide-footer
    :title="title"
    ref="product-require-stock"
    id="product-require-stock"
  >
    <b-row class="mb-4">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group
            v-model="selectedListExcel"
            :disabled="isProcessing"
          >
            <b-form-radio value="filter">Theo bộ lọc</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-progress
      :max="100"
      v-if="isProcessing"
    >
      <b-progress-bar
        :value="processBar"
        :label="`${processBar}% đang tải`"
      ></b-progress-bar>
    </b-progress>
    <b-row class="mt-5">
      <b-col>
        <SaveButton
          :is-busy="isProcessing"
          :button-style="{ fontWeight: '600' }"
          button-class="btn-width-25"
          type="button"
          @click="exportData"
        >
          <i class="fa-solid fa-download"></i>Xuất dữ liệu
        </SaveButton>
        <b-button
          class="btn-width-25 ml-2"
          variant="secondary"
          size="sm"
          :disabled="isProcessing"
          @click="hideModal"
        >Hủy</b-button>
      </b-col>
    </b-row>
  </b-modal>

</template>

<script>
import ApiService from '@/core/services/api.service';
import fileDownload from '@/utils/file-download';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';

export default {
  components: {
    SaveButton,
  },
  mixins: [submitLock],
  props: {
    apiParams: {
      type: Object,
    },
    title: {
      type: String,
    },
    baseUrl: {
      type: String,
    },
  },
  data() {
    return {
      processBar: 0,
      countProcessBar: 0,
      selectedListExcel: 'filter',
    };
  },
  computed: {
    /**
     * Khoá cả nhóm control khi request đang bay (Rule 11 mục 3b). Không khoá nút Hủy thì đóng
     * modal giữa chừng: request server vẫn chạy tới cùng rồi toast bắn trên màn đã đóng.
     */
    isProcessing() {
      return this.isSubmitting('export');
    },
  },
  created() {},
  methods: {
    hideModal() {
      this.$refs['product-require-stock'].hide();
    },
    showModal() {
      this.processBar = 0;
      this.$refs['product-require-stock'].show();
    },
    /**
     * `responseType: 'blob'` nên lỗi về dạng Blob, phải `.text()` rồi parse. Bọc try riêng vì
     * lỗi mạng thì `error.response` undefined, parse thẳng sẽ ném TypeError ngay trong catch.
     */
    async parseBlobError(error) {
      const fallback = 'Không xuất được file Excel';
      try {
        const parsed = JSON.parse(await error.response.data.text());
        return parsed.message || fallback;
      } catch (e) {
        return fallback;
      }
    },
    exportData() {
      return this.withSubmitLock('export', async () => {
        this.processBar = 0;

        let response = null;
        try {
          response = await ApiService.query(this.baseUrl, {
            params: this.apiParams,
            responseType: 'blob',
            onDownloadProgress: function (progressEvent) {
              this.countProcessBar++;
              if (
                progressEvent['srcElement'].response &&
                progressEvent['srcElement'].response.size
              ) {
                this.processBar = 100;
              } else {
                if (this.processBar < 99) {
                  this.processBar += 1;
                }
              }
            }.bind(this),
          });
        } catch (error) {
          makeToastFaile(await this.parseBlobError(error));
          this.hideModal();
          return;
        }

        // Tách khỏi try của request: `getFileName` NÉM khi thiếu Content-Disposition
        // (file-download.js). Để chung một try thì server đã xuất xong mà người dùng vẫn
        // thấy báo lỗi, không hiểu vì sao.
        try {
          const fileName = fileDownload.getFileName(response);
          fileDownload.createFile(response.data, fileName);
          makeToastSuccess('Tải xuống dữ liệu thành công');
        } catch (error) {
          makeToastFaile(error.message || 'Không đọc được tên file trả về');
        }
        this.hideModal();
      });
    },
  },
};
</script>

<style scoped>
.btn-width-25 {
  width: 25%;
  font-weight: 600;
}
</style>
